import { createSelector } from 'reselect'

export default createSelector(
	[ state => state.drawIt.timer ],
	timer => timer
)
